import { TableColumn } from '@/classes'

const Columns = [
  new TableColumn('Type', 'assetType', true, 'asc', 'center'),
  new TableColumn('Direction', 'direction', true, 'asc', 'center'),
  new TableColumn('Status', 'status', true, 'asc', 'center'),
  new TableColumn('Date', 'sentOn', true, 'desc', 'left'),
  new TableColumn('Contact', 'contact', true, 'desc', 'left'),
  new TableColumn('Quote No.', 'quoteNoRef', true, 'desc', 'left'),
  new TableColumn('Claim No.', 'claimNo', true, 'desc', 'left'),
  new TableColumn('Rego', 'rego', true, 'desc', 'left'),
  new TableColumn('Message', 'message', true, 'asc', 'left')
  // new TableColumn('', 'action', false, 'desc', 'centered')
]

export { Columns }
